export { JournalEntriesView } from "../../components/entries/entries-view";
